import styled from 'styled-components';
import { Menu as MuiMenu } from '@material-ui/core';

export const Menu = styled(MuiMenu)`
  & .MuiMenu-list {
    padding: 0 !important;
  }
`;
